export function getAemModel(container, attribute = "") {
    var _a, _b;
    const stringifiedModel = (_b = (_a = container.dataset[attribute]) !== null && _a !== void 0 ? _a : container.dataset.desAppModel) !== null && _b !== void 0 ? _b : "";
    try {
        return JSON.parse(stringifiedModel);
    }
    catch (e) {
        console.error(e);
        return {};
    }
}
//# sourceMappingURL=getAemModel.js.map